module.exports = __webpack_public_path__ + "static/media/prestamista.51a93dbc.svg";